import React from "react";
import { encrypt } from "../../../encryption/Encryption";
import axios from "axios";
import { apiEndPoints } from "../../../../utils/http";
import { toast } from "react-toastify";

const TeacherDetailsPopup = ({
  visible,
  onClose,
  teacher,
  setDisableState,
  getTranslateText,
}) => {
  if (!visible || !teacher || teacher.length === 0) return null; // don't render if no teacher data

  const teacherObj = teacher[0];

  const getTextByKey = (key, fallback) => {
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  function convertTeacherResponse(apiResponse, apiSchoolResponse) {
    if (!apiResponse) return null;

    // Convert DOB from DD-MM-YYYY to YYYY-MM-DD
    const [day, month, year] = apiResponse.DOB.split("-");
    const formattedDOB = `${year}-${month}-${day}`;

    // Map gender: "Male" -> 1, "Female" -> 2, "Transgender" -> 3
    const gender =
      apiResponse.GENDER === "Male"
        ? 1
        : apiResponse.GENDER === "Female"
        ? 2
        : 3;

    // Return the converted object
    return {
      teacherId: apiResponse.TeacherID,
      firstName: apiResponse.TeacherName,
      dob: encrypt(formattedDOB),
      gender: gender,
      mobileNo: encrypt(apiResponse.MobileNumber),
      whatsAppNo: encrypt(apiResponse.WhatsappNumber),
      emailId: encrypt(apiResponse.EmailId),
      udiseCode: apiResponse.School_UDISE,
      schoolName: apiResponse.SCHNAME,
      schoolId: apiSchoolResponse?.schoolId,
      stateId: apiSchoolResponse?.stateId,
      districtId: apiSchoolResponse?.districtId,
      blockId: apiSchoolResponse?.blockId,
      clusterName: apiResponse.ClusterName,
    };
  }

  const onClickYes = async (udiseCode) => {
    try {
      // Call school API
      const convertedUdiseCode = parseInt(udiseCode);
      const response = await axios.get(
        `https://api-school.projectinclusion.in/api${apiEndPoints.GET_SCHOOL_BY_UDISE}?udiseCode=${convertedUdiseCode}`
      );

      if (response?.data?.message === "success") {
        const schoolData = response?.data?.response?.[0];
        const convertedData = convertTeacherResponse(teacherObj, schoolData);

        localStorage.setItem(
          "gsrt_teacher_data",
          JSON.stringify(convertedData)
        );
        //   console.log(convertedData, "converted data");
        setDisableState(true);
        onClose();
      } else {
        toast.error(
          "Your school is not mapped with us. Please contact to support."
        );
        setDisableState(false);
        onClose();
      }
    } catch (error) {
      console.error("Error fetching school data:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex text-left justify-center z-50">
      <div className="bg-white rounded-md shadow-md w-[90%] max-w-6xl p-8 relative">
        {/* Teacher details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="space-y-4">
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("teacher_id", "Teacher ID")}
              </p>
              <p className="font-medium">{teacherObj?.TeacherID}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_dob", "D.O.B")}
              </p>
              <p className="font-medium">{teacherObj?.DOB}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("key_mobile_number", "Mobile Number")}
              </p>
              <p className="font-medium">{teacherObj?.MobileNumber}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_email", "Email ID")}
              </p>
              <p className="font-medium">{teacherObj?.EmailId}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_school", "School Name")}
              </p>
              <p className="font-medium">{teacherObj?.SCHNAME}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_district", "District")}
              </p>
              <p className="font-medium">{teacherObj?.District}</p>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-4">
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_teacher_name", "Teacher Name")}
              </p>
              <p className="font-medium">{teacherObj?.TeacherName}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {" "}
                {getTextByKey("field_gender", "Gender")}
              </p>
              <p className="font-medium">{teacherObj?.GENDER}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_whatsapp_number", "Whatsapp Number")}
              </p>
              <p className="font-medium">{teacherObj?.WhatsappNumber}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("label_udise", "School UDISE")}
              </p>
              <p className="font-medium">{teacherObj?.School_UDISE}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_state", "State")}
              </p>
              <p className="font-medium">{teacherObj?.State}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {getTextByKey("field_block", "Block/Zone")}
              </p>
              <p className="font-medium">{teacherObj?.Block_Zone}</p>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="mt-6 text-center">
          <p className="text-sm font-medium mb-3">
            {getTextByKey(
              "label_please_confirm_details",
              "Please confirm the details once again"
            )}
          </p>
          <div className="flex justify-center gap-4">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg"
            >
              {getTextByKey("alert_no", "No")}
            </button>
            <button
              type="button"
              onClick={() => onClickYes(teacherObj?.School_UDISE)}
              className="px-6 py-2 bg-[#101942] text-white rounded-lg"
            >
              {getTextByKey("alert_yes", "Yes")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherDetailsPopup;
